var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"qrcodejs2"},[_c('div',{ref:_vm.gernerateId,attrs:{"id":_vm.gernerateId}})])}
var staticRenderFns = []

export { render, staticRenderFns }